import { render } from "./GlobalMessenger.vue?vue&type=template&id=626ec3f4&scoped=true"
import script from "./GlobalMessenger.vue?vue&type=script&lang=js"
export * from "./GlobalMessenger.vue?vue&type=script&lang=js"

import "./GlobalMessenger.vue?vue&type=style&index=0&id=626ec3f4&lang=scss&scoped=true"

import exportComponent from "/home/developer/public_html/admin.cureline-crm.cureline.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-626ec3f4"]])

export default __exports__